import type { Metadata } from 'next';

import { DEFAULT_META } from '@/constants';

interface GetMetadataProps {
  title?: string;
  description?: string;
  keywords?: string[];
  canonical?: string;
  images?: string;
  name?: string;
  url?: string;
  type?: string;
}

/**
 * 기본 SEO 메타데이터에 추가된 값만 변경해주는 함수
 */
export const getMetadata = ({
  title,
  description,
  keywords,
  images,
  name,
  canonical,
  url,
  type,
}: GetMetadataProps): Metadata => {
  return {
    ...DEFAULT_META,

    ...(title && { title }),
    ...(description && { description }),
    ...(keywords && { keywords }),
    ...(canonical && {
      alternates: {
        canonical,
      },
    }),
    openGraph: {
      ...DEFAULT_META.openGraph,
      ...(title && { title }),
      ...(images && { images }),
      ...(description && { description }),
      ...(type && { type }),
      ...(url && { url }),
    },
    authors: name
      ? [
          {
            name,
            url: DEFAULT_META.authors[0].url,
          },
        ]
      : DEFAULT_META.authors,
  };
};
